import React, { useState, useEffect } from 'react';
import { Container, Typography, TextField, Button, Box } from '@mui/material';
import { getUserInterests, updateUserInterests } from '../utils/api';

const Interests = () => {
  const [interestsText, setInterestsText] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    // Load existing interests
    getUserInterests()
      .then(data => {
        if (data.interests) {
          // Join interests with commas
          const interestsString = data.interests.map(i => i.label).join(', ');
          setInterestsText(interestsString);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to load interests:', err);
        setLoading(false);
      });
  }, []);

  const handleSave = async () => {
    setSaving(true);
    // Split by comma, trim whitespace, filter out empty strings
    const interestsArray = interestsText
      .split(',')
      .map(i => i.trim())
      .filter(i => i.length > 0);

    try {
      await updateUserInterests(interestsArray);
      alert('Interests updated successfully!');
    } catch (err) {
      console.error('Failed to save interests:', err);
      alert('Failed to save interests');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <Container><Typography>Loading...</Typography></Container>;
  }

  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        My Interests
      </Typography>
      <Typography variant="body1" gutterBottom>
        Enter your interests separated by commas (e.g., music, coding, games)
      </Typography>
      <Box sx={{ mt: 2 }}>
        <TextField
          label="Interests"
          value={interestsText}
          onChange={(e) => setInterestsText(e.target.value)}
          multiline
          rows={4}
          fullWidth
          variant="outlined"
          sx={{
            mb: 2,
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: 'primary.main',
              },
            },
          }}
        />
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={saving}
          fullWidth
        >
          {saving ? 'Saving...' : 'Save Interests'}
        </Button>
      </Box>
    </Container>
  );
};

export default Interests;
